import { supabase } from '@/lib/supabase'
import { deleteCookie } from '@/lib/cookies'
import { IMPERS_STASH_COOKIE } from '../lib/storage-keys'

/**
 * Encerra impersonação na aba atual.
 *
 * A aba de impersonação foi aberta via window.open no startImpersonation
 * (aba admin origem continua aberta em admin.*). Estratégia: limpar o stash
 * cross-subdomínio e fechar ESTA aba. Admin não perde nada — sessão admin vive
 * no localStorage/cookie da outra aba, intacta porque a aba de impersonação
 * nunca escreveu no cookie mirror (isolamento em supabase.ts).
 *
 * Se window.close falhou (browser bloqueou — raro quando foi aberta via
 * window.open), fallback: limpa sessão local e manda pro /login.
 */
export async function endImpersonation(clearLocalStash: () => void): Promise<void> {
  deleteCookie(IMPERS_STASH_COOKIE)
  // NÃO remover IMPERS_ACTIVE_TAB_KEY antes do signOut — sessionStorage é
  // per-tab e a aba está fechando; manter a flag garante que o signOut
  // fallback não limpa o cookie de sessão admin do outro subdomínio.
  window.close()

  // Aguarda um tick pra dar chance do close real acontecer.
  await new Promise(resolve => setTimeout(resolve, 50))
  clearLocalStash()
  await supabase.auth.signOut().catch(() => {/*ignore*/})
  window.location.href = '/login'
}
